export enum EAiModelType {
  RETROSYNTHESIS = 'retrosynthesis',
  REACTION = 'reaction',
  SYNTHESIS = 'smiles2actions',
  REACTION_COMPLETION = 'reactioncompletion',
}
